import {FC} from 'react'
import {PageLink} from '../../../_metronic/layout/core'
import {KTCard} from '../../../_metronic/helpers'
import {AssetManagement} from './AssetManagement'
import {AssetPageTitle} from '../../../_metronic/layout/core/AssetPageData'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const AssetManagementWrapper: FC = () => {
  return (
    <>
      <AssetPageTitle
        icon='Icon-1.svg'
        title='Asset Management'
        // desc={`${parentDataCount + ' ' + 'assets'}`}
        desc='Monitor your devices and repositories that are within your audit scope'
        breadcrumbs={usersBreadcrumbs}
      >
        Asset Inventory Management
      </AssetPageTitle>
      <KTCard>
        <AssetManagement />
      </KTCard>
    </>
  )
}

export default AssetManagementWrapper
